'use strict';

import $ from 'jquery'; // eslint-disable-line no-unused-vars
import ModalView from '../../js/components/ModalView';
import cookies from 'js-cookie';
import config from '../../js/config';
import unauthenticatedBomModal from './templates/BomUnauthenticatedModal.hbs';

let instance = null;

export default class BomUnauthenticatedModal extends ModalView {
  initialize() {
    super.initialize({ template: unauthenticatedBomModal, remodal: { closeOnOutsideClick: false } });
  }

  initializeElements() {
    this.$focusableInNav = $('#BomUnauthenticated-modal [href],#BomUnauthenticated-modal [tabindex]:not([tabindex="-1"])');
    this.$firstFocusableElement = this.$focusableInNav.first();
    this.$lastFocusableElement = this.$focusableInNav.last();
    this.$modalContainer = this.$el.find('#BomUnauthenticated-modal');
    this.$lastActiveElement = $(document.activeElement);
    this.$loginLink = this.$el.find('#bommodalloginlink');
    this.$registerLink = this.$el.find('#bommodalregisterlink');
    this.url = encodeURIComponent(window.location.href);
    this.registerUrl = '/register?gotoURL=' + this.url;
    this.loginUrl = '/login?url=' + this.url;
    this.$loginLink.attr('href',this.loginUrl);
    this.$registerLink.attr('href',this.registerUrl);
    cookies.set(config.cookies.sessionExtend, false);
    window.addEventListener('unload', function(event)  {
      this.modalClosing();
      });
  }

  open() {
    this.renderModal();
    super.open();
  }

  modalClosing() {
    super.modalClosing();
    this.$modalContainer.removeAttr('aria-modal');
    this.$lastActiveElement.focus();
  }

  renderModal() {
    // Render main view
    this.$el.html(this.template());
  }

  onOpen() {
    this.initializeElements();
    this.$modalContainer.attr('aria-modal',true);
    this.$modalContainer.parent().removeAttr('tabindex');
    this.$modalContainer.focus();
    this.$firstFocusableElement.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastFocusableElement.focus();
      }
    });
    this.$lastFocusableElement.on('keydown', (e)=>{
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstFocusableElement.focus();
      }
    });
  }

  static getInstance() {
    if (!instance) {
      instance = new BomUnauthenticatedModal();
    }

    return instance;
  }

}


// WEBPACK FOOTER //
// ./assets/components/BomModal/BomUnauthenticatedModal.js